import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { GAContext } from 'contexts/GAContext';

import SelectionButtons from '../buttons/SelectionButtons';
import ColorListBox from '../ColorsListBody';
import SummaryBar from '../SummaryBar';
import RangeSlider from '../common/RangeSlider';
import { PriceContext } from '../../contexts/PriceContext';
import PopUp from '../popup/PopUp';
import CleanAccessoriesPopup from '../popup/CleanAccessoriesPopup';
import calculatePrice from '../../helpers/calculatePrice';
import WardrobeInfo from '../buttons/WardrobeInfo';
import DoorTypesPopupContent from '../popup/DoorTypesPopupContent';

const openPopup = () => {
  const popup = document.querySelector(`[data-popup-name="clean-accessories"]`);
  if (!!popup) {
    popup.classList.add('open');
  }
};

function compareDimensions(wardrobesConfigs, copyWardrobe, activeWardrobe) {
  if (copyWardrobe.length) {
    return (
      wardrobesConfigs[activeWardrobe].dimensions.x !== copyWardrobe[activeWardrobe].dimensions.x ||
      wardrobesConfigs[activeWardrobe].dimensions.z !== copyWardrobe[activeWardrobe].dimensions.z
    );
  }
  return false;
}

function getDepthDimm(activeWardrobe, wardrobesConfigs, cornerIndex, dimensions) {
  if (cornerIndex === -1) {
    if (dimensions >= 0) {
      return 45;
    } else {
      return 66;
    }
  } else {
    return 66;
  }
}

const SimpleWardrobeBodyConfig = ({ wardrobeHulls, defaultFront, dimensions, slidePoints }) => {
  const history = useHistory();

  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice } = useContext(PriceContext);
  const { height } = useContext(WardrobeHeightContext);
  const { GA } = useContext(GAContext);

  const wardrobe = wardrobesConfigs[activeWardrobe];
  const copyWardrobe = reactLocalStorage.getObject('copyWardrobe');

  const cornerIndex = wardrobesConfigs.findIndex(config => config.is_corner === true);
  const wardrobe45 = wardrobesConfigs.findIndex(config => config.dimensions.z === 45);

  const depthDimm = getDepthDimm(activeWardrobe, wardrobesConfigs, cornerIndex, wardrobe45);
  const wardrobeSafo = wardrobe.safo.split('-').pop();

  const canChangeDepth = wardrobeHulls.find(item => {
    return (
      item.safo.includes(wardrobeSafo) &&
      item.dimensions.z !== wardrobe.dimensions.z &&
      item.dimensions.y === wardrobe.dimensions.y &&
      item.dimensions.x === wardrobe.dimensions.x
    );
  });
  const [colorsList, setColorsList] = useState([]);
  const [bodyState, setBodyState] = useState({
    filter: {
      x: copyWardrobe.length ? wardrobe.dimensions.x : 200,
      y: height,
      z: copyWardrobe.length ? wardrobe.dimensions.z : depthDimm,
    },
    activeMat: wardrobesConfigs[0].safo ? wardrobesConfigs[0].safo : null,
  });

  const cleanAccessories = () => {
    localStorage.removeItem('copyWardrobe');
    let wardrobe = [...wardrobesConfigs];
    wardrobe[activeWardrobe].accessories = {
      left: [],
      center: [],
      right: [],
    };
    setWardrobesConfigs(wardrobe);
    history.push('/wardrobe-fronts-configuration');
  };

  const restoreWardrobe = () => {
    setWardrobesConfigs(copyWardrobe);
    setBodyState({
      ...bodyState,
      filter: copyWardrobe[activeWardrobe].dimensions,
    });
  };

  const checkDimensions = compareDimensions(wardrobesConfigs, copyWardrobe, activeWardrobe);

  const setFilter = (value, index) => {
    let color, filter;

    if (index === 'color') {
      color = value.split('-').pop();
      filter = { ...bodyState.filter };
    } else {
      color = bodyState.activeMat.split('-').pop();
      filter = {
        ...bodyState.filter,
        [index]: value,
      };
    }

    const filteredData = wardrobeHulls
      .filter(item => {
        return (
          item.dimensions.y === filter.y &&
          item.dimensions.x === filter.x &&
          item.dimensions.z === filter.z
        );
      })
      .sort((a, b) => {
        return a.safo.localeCompare(b.safo);
      });

    const newActiveMat = filteredData.find(item => {
      return item.safo.split('-').pop() === color;
    });

    if (newActiveMat !== undefined) {
      const ActiveMat = {
        ...newActiveMat,
        accessories: wardrobe.accessories,
        handles: wardrobe.handles,
        fronts: wardrobe.fronts,
        defaultFronts: wardrobe.defaultFronts,
        brake: wardrobe.brake,
        addons: wardrobe.addons,
      };
      ActiveMat.defaultFronts = [];
      const selectedDefaultFront = defaultFront[ActiveMat.is_hinged ? 8 : 7];
      if (!ActiveMat.is_hinged) {
        ActiveMat.defaultFronts = selectedDefaultFront[ActiveMat.panels];
      } else {
        ActiveMat.defaultFronts = selectedDefaultFront;
      }
      if (index === 'z' || index === 'x') {
        ActiveMat.fronts = !ActiveMat.is_hinged ? [[], []] : [];
        ActiveMat.handles = {
          left: null,
          right: null,
        };
        ActiveMat.addons = {
          brake: null,
          fronts: null,
          lights: null,
          track: null,
        };
      }
      wardrobesConfigs[activeWardrobe] = ActiveMat;
      setBodyState({
        ...bodyState,
        filter: filter,
        activeMat: newActiveMat.safo,
      });

      setColorsList(filteredData);
      setWardrobesConfigs(wardrobesConfigs);
    }
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const setDepthInternal = value => {
    setFilter(value, 'z');
  };

  const setWidthInternal = value => {
    setFilter(value[0], 'x');
  };

  const setMaterial = value => {
    GA('Wardrobe Body', 'SelectBody');
    setFilter(value.safo, 'color');
  };

  const depthArr = () => {
    if (!canChangeDepth && !!dimensions) {
      if (wardrobe.dimensions.z === 45) {
        return [45];
      } else {
        return [66];
      }
    } else {
      return Object.keys(dimensions.depth).map(item => dimensions.depth[item]);
    }
  };

  useEffect(() => {
    if (!Object.prototype.hasOwnProperty.call(copyWardrobe, 'length')) {
      if (wardrobesConfigs.length > 0) {
        const wardrobe = JSON.parse(JSON.stringify(wardrobesConfigs));
        wardrobe[activeWardrobe].accessories = {
          left: [],
          center: [],
          right: [],
        };

        let cntPanels = 0;
        if (!wardrobesConfigs[activeWardrobe].is_hinged) {
          wardrobesConfigs[activeWardrobe].fronts.forEach(item => {
            item.forEach(panel => {
              cntPanels += panel !== null && panel.hasOwnProperty('safo') ? 1 : 0;
            });
          });
        } else {
          wardrobesConfigs[activeWardrobe].fronts.forEach(item => {
            cntPanels += item !== null && item.hasOwnProperty('safo') ? 1 : 0;
          });
        }

        if (!cntPanels) {
          wardrobe[activeWardrobe].fronts = !wardrobesConfigs[activeWardrobe].is_hinged
            ? [[], []]
            : [];
        }

        wardrobe[activeWardrobe].dimensions.z = depthDimm;
        setWardrobesConfigs(wardrobe);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (colorsList.length === 0) {
      const colors = wardrobeHulls
        .filter(item => {
          return (
            item.dimensions.y === wardrobe.dimensions.y &&
            item.dimensions.x === wardrobe.dimensions.x &&
            item.dimensions.z === wardrobe.dimensions.z
          );
        })
        .sort((a, b) => {
          return a.safo.localeCompare(b.safo);
        });
      setColorsList(colors);
    }
  }, [
    colorsList.length,
    wardrobe.dimensions.x,
    wardrobe.dimensions.y,
    wardrobe.dimensions.z,
    wardrobeHulls,
  ]);

  useEffect(() => {
    wardrobesConfigs.forEach(config => {
      if (wardrobe.id === config.id) {
        let randomStr = Math.random().toString(36).substring(7);
        wardrobe.id = wardrobe.id.slice(0, -6) + randomStr;
      }
    });

    const { x, y, z } = bodyState.filter;
    if (x !== wardrobe.dimensions.x || y !== wardrobe.dimensions.y || z !== wardrobe.dimensions.z) {
      setBodyState(prev => {
        return {
          ...prev,
          activeMat: wardrobe.safo,
          filter: { x: wardrobe.dimensions.x, y: wardrobe.dimensions.y, z: wardrobe.dimensions.z },
        };
      });
    }
  }, [
    bodyState.filter,
    colorsList.length,
    wardrobe.dimensions.x,
    wardrobe.dimensions.y,
    wardrobe.dimensions.z,
    wardrobe.id,
    wardrobe.safo,
    wardrobesConfigs,
  ]);

  let cntWardrobes = wardrobesConfigs.length === 1;

  if (cornerIndex !== -1) {
    const corner = wardrobesConfigs[cornerIndex];
    const z = wardrobesConfigs[activeWardrobe].dimensions.z;
    const x = corner.dimensions.x;
    const cornerType = corner.types;
    if (x === 97) {
      if (cornerIndex < activeWardrobe) {
        cntWardrobes =
          wardrobesConfigs[cornerIndex + 1].dimensions.z !== z
            ? true
            : parseInt(activeWardrobe) - 1 === cornerIndex;
        if (wardrobesConfigs[parseInt(activeWardrobe) - 1].dimensions.z === 45) {
          wardrobe.dimensions.z = 45;
        }
      }
      if (cornerIndex > activeWardrobe) {
        cntWardrobes =
          wardrobesConfigs[cornerIndex - 1].dimensions.z !== z
            ? true
            : parseInt(activeWardrobe) + 1 === cornerIndex
            ? cornerType[10].includes('45x66')
              ? false
              : true
            : false;
      }
    }
    if (x === 66) {
      if (cornerIndex < activeWardrobe) {
        cntWardrobes =
          wardrobesConfigs[cornerIndex + 1].dimensions.z !== z
            ? true
            : parseInt(activeWardrobe) - 1 === cornerIndex
            ? cornerType[9].includes('66x45')
              ? false
              : true
            : false;
      }
      if (cornerIndex > activeWardrobe) {
        cntWardrobes =
          wardrobesConfigs[cornerIndex - 1].dimensions.z !== z
            ? true
            : parseInt(activeWardrobe) + 1 === cornerIndex;
        if (wardrobesConfigs[parseInt(activeWardrobe) + 1].dimensions.z === 45) {
          wardrobe.dimensions.z = 45;
        }
      }
    }
  }

  return (
    <>
      <div className="container wardrobe-config">
        {cntWardrobes && (
          <SelectionButtons
            title={
              bodyState.filter.x < 120 ? (
                <span>
                  Głębokość szafy:{' '}
                  <span
                    data-tip="Podana głębokość nie uwzględnia grubości frontów."
                    data-for="simple-tooltip-wardrobe"
                    className="icon-help-circle"
                  />
                  <ReactTooltip className="wardrobe-config__tooltip" id="simple-tooltip-wardrobe" />
                </span>
              ) : (
                'Głębokość szafy:'
              )
            }
            params={depthArr()}
            unit="cm"
            selectionGroupName="wardrobe-depth"
            setValue={setDepthInternal}
            activeValue={bodyState.filter.z}
          />
        )}
        <RangeSlider
          slidePoints={slidePoints}
          sliderName="Szerokość:"
          activeValue={bodyState.filter.x}
          unit="cm"
          changeSize={setWidthInternal}
          wardrobesConfigs={wardrobesConfigs}
          setWardrobesConfigs={setWardrobesConfigs}
          activeWardrobe={activeWardrobe}
        />
        {false &&
          window.location.pathname === '/konfigurator-flex/wardrobe-body-configuration' &&
          (wardrobesConfigs[activeWardrobe].is_corner ? null : (
            <>
              <WardrobeInfo
                wardrobesDimensions={!wardrobesConfigs[activeWardrobe].is_hinged}
                popupName="door-info-popup"
              />
              <PopUp popupName="door-info-popup" title="Rodzaj drzwi">
                <div className="container">
                  <DoorTypesPopupContent />
                </div>
              </PopUp>
            </>
          ))}
        <ColorListBox
          title={`Kolor korpusu: ${wardrobesConfigs[activeWardrobe].name}`}
          activeValue={bodyState.activeMat}
          changeMaterial={setMaterial}
          colorsList={colorsList}
          propClass="color-list--small-margin-bottom"
        />
        <span className="wardrobe-config__info">
          Wnętrze szafy oraz wyposażenie dodatkowe występuje w kolorystyce szare płótno
        </span>
        {checkDimensions ? (
          <SummaryBar btnText="Przejdź dalej" btnFunction={openPopup} btnIcon={true} />
        ) : (
          <SummaryBar
            btnText="Przejdź dalej"
            btnIcon={true}
            btnLink="/wardrobe-fronts-configuration"
          />
        )}
      </div>
      <PopUp
        title="Czy chcesz kontynuować?"
        popupName="clean-accessories"
        buttonText="przywróć"
        additionalFunc={restoreWardrobe}>
        <CleanAccessoriesPopup cleanAccessories={cleanAccessories} />
      </PopUp>
    </>
  );
};

const mapStateToProps = state => {
  return {
    wardrobeHulls: state.products.wardrobeHulls,
    dimensions: state.dimensions.dimensions,
    defaultFront: state.defaults.front,
  };
};

export default connect(mapStateToProps)(SimpleWardrobeBodyConfig);
